import { WidgetElementType } from "@redotech/redo-storefront-common/widget-config";
import { WidgetConfig } from "@redotech/redo-storefront-widget-common/widget";
import { StorefrontCoverageHtmlElement } from "../cart-app";

export function hasValidButtonSelectors(
  toggles: {
    redoHtmlElements: StorefrontCoverageHtmlElement[];
    widgetConfig?: WidgetConfig;
  }[],
): boolean {
  const usingWidgetConfigs = toggles.some(
    ({ redoHtmlElements, widgetConfig }) => !!widgetConfig,
  );

  if (!usingWidgetConfigs) {
    return false;
  }

  const checkoutButtonElements = toggles.filter(
    ({ redoHtmlElements, widgetConfig }) => {
      return (
        widgetConfig?.elementType === WidgetElementType.BOTH_CHECKOUT_BUTTONS ||
        widgetConfig?.elementType ===
          WidgetElementType.COVERAGE_CHECKOUT_BUTTON ||
        widgetConfig?.elementType ===
          WidgetElementType.NON_COVERAGE_CHECKOUT_BUTTON
      );
    },
  );

  // bail only if EVERY checkout button is hidden — a hidden copy in a closed cart shouldn't block the visible one
  if (
    checkoutButtonElements.every(({ redoHtmlElements }) =>
      redoHtmlElements.every((element) => {
        return window.getComputedStyle(element).display === "none";
      }),
    )
  ) {
    return false;
  }

  if (
    checkoutButtonElements.every(
      ({ redoHtmlElements, widgetConfig }) => redoHtmlElements.length === 0,
    )
  ) {
    return false;
  }

  return true;
}
